import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { ItemCategory, ItemCategoryResponse } from '../interfaces/item-category.interface';
import {AuthService} from "./auth.service";

export const ItemCategoryService = {
    getItemCategoriesByInstitution: async (page: number = 0, size: number = 10): Promise<ItemCategoryResponse> => {
        const institutionId = AuthService.getSelectedInstitution();
        const response = await axios.get(`${ENDPOINTS.ITEM_CATEGORY.LIST_BY_INSTITUTION}/${institutionId}?page=${page}&size=${size}`);
        return response.data;
    },

    createItemCategory: async (itemCategory: ItemCategory): Promise<ItemCategory> => {
        return (await axios.post(ENDPOINTS.ITEM_CATEGORY.BASE, itemCategory)).data;
    },

    updateItemCategory: async (id: string, itemCategory: ItemCategory): Promise<ItemCategory> => {
        return (await axios.put(ENDPOINTS.ITEM_CATEGORY.UPDATE(id), itemCategory)).data;
    },

    deleteItemCategory: async (id: string): Promise<void> => {
        await axios.delete(ENDPOINTS.ITEM_CATEGORY.DELETE(id));
    }
};
